import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { useFormik } from "formik";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Button } from "../../ui/button";

const TranslationModal = ({
  open,
  onClose,
  initialValues,
  onSave,
  title = "Edit Translations",
}: {
  open: boolean;
  onClose: (open: boolean) => void;
  initialValues: Record<string, string>;
  onSave: (values: Record<string, string>) => void;
  title?: string;
}) => {
  const formik = useFormik({
    initialValues,
    onSubmit: (values) => {
      onSave(values);
      onClose(false);
    },
  });

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="z-50 bg-[rgba(0,0,0,.6)] fixed inset-0" />

        <Dialog.Content className="z-50 fixed top-[50%] left-[50%] max-h-[90vh] w-full max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-blackLight p-6 focus:outline-none text-body">
          <h2 className="text-lg font-semibold mb-4">{title}</h2>

          <form onSubmit={formik.handleSubmit} className=" space-y-4">
            {Object.keys(formik.values).map((lang) => (
              <div key={lang} className="space-y-1 ">
                <Label className="block text-body mb-2 text-sm px-1">
                  {`Layer Name (${lang.toUpperCase()})`}
                </Label>
                <Input
                  name={lang}
                  value={formik.values[lang]}
                  onChange={formik.handleChange}
                  className="input-ring bg-transparent text-white placeholder"
                />
              </div>
            ))}

            <div className="flex justify-end pt-4 space-x-2">
              <Button
                type="button"
                onClick={() => onClose(false)}
                className="bg-transparent text-muted hover:bg-borderColor text-sm px-4 py-1.5 rounded"
              >
                Cancel
              </Button>

              <Button
                type="submit"
                className="bg-primary text-white text-sm px-4 py-1.5 rounded"
              >
                Save
              </Button>
            </div>
          </form>

          <Dialog.Close asChild>
            <button
              className="absolute top-3 right-3"
              aria-label="Close"
              onClick={() => onClose(false)}
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default TranslationModal;
